import * as zoid from 'zoid/dist/zoid.frameworks';
import appConfig from '../../../../app.config';

export const ApplyForCredit = zoid.create({
  tag: '_VCI-COFA-VW',
  url: appConfig.api.vwf,
  dimensions: {
    width: '100%',
    height: '100%'
  }
});
